var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappButtonPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5779 8.04931L9.1451 7.88573C8.97663 7.86594 8.80586 7.88459 8.64563 7.94028C8.4854 7.99597 8.33987 8.08725 8.21999 8.20726L7.18205 9.24519C5.58069 8.43077 4.2791 7.12917 3.46467 5.52781L4.50824 4.48424C4.75081 4.24168 4.86927 3.90322 4.82978 3.55912L4.66619 2.13761C4.63421 1.86243 4.50215 1.60862 4.29515 1.42451C4.08815 1.24039 3.82067 1.13883 3.54364 1.13916H2.56776C1.93033 1.13916 1.40009 1.66941 1.43957 2.30684C1.73854 7.1242 5.59131 10.9713 10.403 11.2703C11.0405 11.3098 11.5707 10.7795 11.5707 10.1421V9.16622C11.5763 8.59649 11.1476 8.11701 10.5779 8.04931Z",
    fill: "#2684BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappButtonPhoneIcon);
export default __webpack_public_path__ + "static/media/whatsapp-button-phone-icon.6bcde649c017e214527cb6bf74f5a745.svg";
export { ForwardRef as ReactComponent };